import styled from 'styled-components';

export const StyledCode = styled.code`
  font-size: 97.5%;
  color: #da1783;
  word-wrap: break-word;
  padding: 0.15rem;
`;
